var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5455 0H4.45455C1.99341 0 0 1.99341 0 4.45455V44.5455C0 47.0066 1.99341 49 4.45455 49H44.5455C47.0066 49 49 47.0066 49 44.5455V4.45455C49 1.99341 47.0044 0 44.5455 0ZM41.6255 21.1012C41.336 21.1279 41.0442 21.1457 40.7502 21.1457C37.4204 21.1457 34.4938 19.4352 32.7899 16.8449C32.7899 23.6358 32.7899 31.3645 32.7899 31.4936C32.7899 37.4739 27.9411 42.3204 21.9631 42.3204C15.9851 42.3182 11.1364 37.4694 11.1364 31.4914C11.1364 25.5112 15.9851 20.6646 21.9631 20.6646C22.1903 20.6646 22.4108 20.6847 22.6313 20.698V26.0346C22.4086 26.0079 22.1925 25.9678 21.9631 25.9678C18.9118 25.9678 16.4373 28.4423 16.4373 31.4936C16.4373 34.545 18.9095 37.0195 21.9631 37.0195C25.0167 37.0195 27.7117 34.614 27.7117 31.5627C27.7117 31.4402 27.7652 6.68405 27.7652 6.68405H32.8634C33.3423 11.2433 37.024 14.8425 41.6255 15.1722V21.1012Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.d86363730ecb03290777edee669e375d.svg";
export { ForwardRef as ReactComponent };